import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import Config from '../config/config';
import { openLink } from '../functions/newTab';
import './page.css';

export default function Attractions() {
    return (
        <div className="attractions">
            <Container>
                <Row className="justify-content-center">
                    <CardsOfAttraction attractions={Config.ATTRACTIONS} />
                </Row>
            </Container>
        </div>
    );
}

function CardsOfAttraction({ attractions }) {
    return attractions.map(attraction => (
        <Col md={3} className="mb-4" key={attraction.link}>
            <Card className="h-100">
                <Card.Img variant="top" src={attraction.image} className="card-img" />
                <Card.Body className="d-flex flex-column justify-content-between">
                    <Card.Title>{attraction.title}</Card.Title>
                    <Button onClick={() => openLink(attraction.link)}>Dowiedz się więcej</Button>
                </Card.Body>
            </Card>
        </Col>
    ));
}
